export const senderSmallSecondaryButtonClass =
  "!h-[28px] !px-2 !rounded-md !border-border_white_transparent20 hover:!bg-background_white_overlay5";
